import styled from "styled-components";

const StyledCollectionCard = styled.div`
  padding: 16px 24px;
  svg {
    width: 4px;
    height: 20px;
    color: ${({ theme }) => theme.palette.neutral3};
  }
`;

export default StyledCollectionCard;
